import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useStyles from './styles'
import WidgetTitle from 'components/common/WidgetTitle/WidgetTitle'
import { Widget } from 'data/Show'
import SocialLinkIcons from 'data/SocialLinkIcons'

interface WidgetLinksProps {
    widget: Widget
}

const WidgetLinks: React.FC<WidgetLinksProps> = ({ widget }) => {
    const classes = useStyles()
    return (
        <section>
            <WidgetTitle heading={widget.content.heading} />
            <div>
                {widget.content.links?.map((link, index) => {
                    const icon = SocialLinkIcons[link.type]
                    return (
                        <a
                            href={link.linkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.link}
                            id={`social-${icon.iconName}`}
                            key={index}
                        >
                            <FontAwesomeIcon className={classes.icon} icon={icon} />
                            <span className={classes.iconName}>{link.type}</span>
                        </a>
                    )
                })}
            </div>
        </section>
    )
}

export default React.memo(WidgetLinks)
